<div class="comment-box">
  <div class="title">{{ title() | titlecase }}</div>
  <div class="comments" #commentsContainer>
    @if (loading()) {
      <div>
        <h3>{{ 'shared.fetchingComments' | translate }}</h3>
      </div>
    }
    @for (comment of comments(); track comment) {
      @if (editingComment()?.id === comment.id) {
        <!-- Edit form rendered by CommentsComponent — reuses existing mention infrastructure -->
        <div class="comment-edit-inline" [ngClass]="{ 'other flt-left': !comment.itsMe, 'mines flt-right': comment.itsMe }">
          <textarea
            class="edit-textarea"
            [(ngModel)]="editText"
            rows="3"
            maxlength="1000"
            (input)="autoSuggestUsers() ? onTextInput($event) : null"
            (keydown)="onKeyDown($event)">
          </textarea>
          <div class="edit-actions">
            <button mat-button class="save-btn" (click)="saveEditComment()">Save</button>
            <button mat-button (click)="cancelEditComment()">Cancel</button>
          </div>
        </div>
      } @else {
        <div miq-entry-comment [comment]="comment" (editRequested)="startEditComment($event)"></div>
      }
    }
  </div>

  <div class="ava-comments" [formGroup]="messageGroup">
    <div class="input-with-button">
      <mat-form-field appearance="outline">
        <input
          #messageInput
          matInput
          autocomplete="no-autofill"
          [placeholder]="'shared.writeYourComment' | translate"
          formControlName="message"
          (keyup.enter)="!autoSuggestUsers() ? sendMessage($event) : null"
          (input)="autoSuggestUsers() ? onTextInput($event) : null"
          (keydown)="autoSuggestUsers() ? onKeyDown($event) : null"
          />
        </mat-form-field>
        <button mat-button (click)="sendMessage($event)">
          <mat-icon>send</mat-icon>
        </button>
      </div>
    </div>
    <div></div>
  </div>

  <!-- Mention backdrop + dropdown sit at comment-box level (position:absolute inside
       position:relative .comment-box) so they scroll with the page naturally. -->
  @if (autoSuggestUsers() && (showMentionDropdown() || mentionSearchLoading())) {
    <div class="mention-backdrop" (click)="closeMentionDropdown()"></div>
    <div class="mention-dropdown"
      [style.top.px]="dropdownPosition.top"
      [style.left.px]="dropdownPosition.left">
      @if (mentionSearchLoading()) {
        <div class="mention-loading">
          <mat-spinner [diameter]="16"></mat-spinner>
        </div>
      }
      <!-- Previous results stay visible (under the spinner) while refreshing;
           they are still selectable — selecting cancels the in-flight search. -->
      @if (showMentionDropdown()) {
        @for (user of mentionUsers(); track user; let i = $index) {
          <div
            class="mention-item"
            [class.selected]="i === selectedMentionIndex()"
            (click)="selectMention(user)">
            {{ user.firstName }}, {{ user.lastName }} - ({{ user.emailAddress }})
          </div>
        } @empty {
          @if (!mentionSearchLoading()) {
            <div class="mention-no-results">{{ 'shared.noMatchingRecordsFound' | translate }}</div>
          }
        }
      }
    </div>
  }
